import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "delivery-pending-detail" }
const _hoisted_2 = { class: "background-grey-lighten-5 px-6 py-6 mb-4 rounded-lg" }
const _hoisted_3 = { class: "sm:flex w-full items-center justify-between" }
const _hoisted_4 = { class: "font-bold py-2 text-2xl md:text-3xl" }
const _hoisted_5 = { class: "sm:flex items-center" }
const _hoisted_6 = { class: "flex batas-chip mr-3 pr-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "font-normal color-blue-grey-darken-3 text-base mr-1" }, "Berangkat : ", -1)
const _hoisted_8 = { class: "color-blue-grey-darken-3 text-base" }
const _hoisted_9 = { class: "flex items-center mt-3 sm:mt-0" }
const _hoisted_10 = {
  class: "rounded-md background-green-lighten-5 py-1 px-3 mr-2",
  style: {"border":"1px solid #66BB6A"}
}
const _hoisted_11 = { class: "color-green-darken-1 text-sm" }
const _hoisted_12 = {
  class: "rounded-md background-grey-lighten-5 py-1 px-3",
  style: {"border":"1px solid #607D8B"}
}
const _hoisted_13 = {
  key: 0,
  class: "color-blue-grey text-sm"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "flex rounded-full background-green p-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-check text-white w-4 h-4 text-bold" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-black" }, "Sudah Diproses", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-black" }, "Proses Pendapatan", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableFinishedProcessingDetail = _resolveComponent("TableFinishedProcessingDetail")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("p", _hoisted_4, _toDisplayString(_ctx.dataHeader.KodeJadwal), 1)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.moment(_ctx.dataHeader.TanggalAktif).format('dddd, DD MMMM YYYY')), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("p", _hoisted_11, "RIT " + _toDisplayString(_ctx.dataHeader.Rit), 1)
              ]),
              _createVNode("div", _hoisted_12, [
                (_ctx.dataHeader.TipeBus)
                  ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.dataHeader.TipeBus.Kode), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      content: _withCtx(() => [
        (_ctx.showTableFinished)
          ? (_openBlock(), _createBlock(_component_TableFinishedProcessingDetail, {
              key: 0,
              jadwalId: Number(_ctx.decryptData()),
              dataHeader: _ctx.dataHeader,
              ref: "refTableFinished"
            }, null, 8, ["jadwalId", "dataHeader"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        (_ctx.dataHeader.IsClose)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "btn-secondary p-button-sm flex gap-2 cursor-default"
            }, {
              default: _withCtx(() => [
                _hoisted_14,
                _hoisted_15
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "btn-primary p-button-sm rounded-md",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.prosesPendapatan()))
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ]))
}